import { render } from "./TermAssurancePolicyDetails.vue?vue&type=template&id=bfa98dbe&scoped=true"
import script from "./TermAssurancePolicyDetails.vue?vue&type=script&lang=js"
export * from "./TermAssurancePolicyDetails.vue?vue&type=script&lang=js"

import "./TermAssurancePolicyDetails.vue?vue&type=style&index=0&id=bfa98dbe&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa98dbe"]])

export default __exports__